import { Box, Button, Section, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import {
  FinancialWorkspaceSettingsProvider,
  useFinancialWorkspaceSettings,
} from './FinancialWorkspaceSettingsProvider'
import { SettingsFormFields } from './SettingsFormFields'
import { WarningBanner } from './WarningBanner'

const FinancialWorkspaceSettingsContent = () => {
  const {
    setFieldValue,
    dirty,
    handleSubmit,
    loading,
    showResetButton,
    handleReset,
    showBanner,
    isResetting,
    defaultConceptIdsToAdd,
    defaultConceptIdsToSubtract,
    setExpensesConceptMissing,
  } = useFinancialWorkspaceSettings()

  return (
    <ResponsivePage.Body variant="wide" showHeader={false}>
      <Section.Form
        disabled={loading}
        illustration="money"
        submitLabel={i18n.t('common.submit')}
        title={i18n.t('finance.financial_workspace.settings.labor_cost.title')}
        description={i18n.t('finance.financial_workspace.settings.labor_cost.description_v2')}
      >
        <Text.Normal weight="semibold" size="300">
          {i18n.t('finance.financial_workspace.settings.labor_cost.form_title')}
        </Text.Normal>
        <SettingsFormFields
          setFieldValue={setFieldValue}
          defaultConceptIdsToAdd={defaultConceptIdsToAdd}
          defaultConceptIdsToSubtract={defaultConceptIdsToSubtract}
          setExpensesConceptMissing={setExpensesConceptMissing}
        />
        {showBanner && <WarningBanner />}

        <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
          {(showResetButton || isResetting) && (
            <Button type="secondary" disabled={isResetting} onClick={() => handleReset()}>
              {i18n.t('common.reset')}
            </Button>
          )}
          {dirty && (
            <Button type="primary" disabled={loading} onClick={() => handleSubmit()}>
              {i18n.t('common.submit')}
            </Button>
          )}
        </Box>
      </Section.Form>
    </ResponsivePage.Body>
  )
}

const FinancialWorkspaceSettings = () => {
  return (
    <FinancialWorkspaceSettingsProvider>
      <FinancialWorkspaceSettingsContent />
    </FinancialWorkspaceSettingsProvider>
  )
}

export default FinancialWorkspaceSettings
